import LogtedUserNavBar from "./LogtedUserNavBar";
import NotLogtedUserNavBar from "./NotLogtedUserNavBar";

import { useAuth0 } from "@auth0/auth0-react";
import { useContext } from "react";
import { UserContex } from "./App2";
//
export default function NavBar() {
  const { state } = useContext(UserContex);
  const { isAuthenticated, isLoading } = useAuth0();
  function Check() {
    if (state) {
      return state ? <LogtedUserNavBar /> : <NotLogtedUserNavBar />;
    } else {
    }
    if (isAuthenticated) {
      return isAuthenticated ? <LogtedUserNavBar /> : <NotLogtedUserNavBar />;
    }
  }
  if (isLoading) {
    return <p>Loading...</p>;
  }
  // console.log(state, isAuthenticated);
  // main return
  return (
    <>
      {isAuthenticated ? (
        <Check />
      ) : state ? (
        <LogtedUserNavBar />
      ) : (
        <NotLogtedUserNavBar />
      )}
    </>
  );
}
